import { useAsync } from 'react-use';

import { logger } from '@service-initiation/shared-clients-osp-logger';

import { createReserveWithGoogleConversion } from '../createReserveWithGoogleConversion';
import { getReserveWithGoogleToken } from '../utils';

export const useCreateReserveWithGoogleConversion = () =>
  useAsync(async () => {
    const rwgToken = getReserveWithGoogleToken();
    const conversionPartnerId =
      process.env['NX_PUBLIC_RESERVE_WITH_GOOGLE_PARTNER_ID'];

    if (!conversionPartnerId) {
      const err = new Error(
        'NX_PUBLIC_RESERVE_WITH_GOOGLE_PARTNER_ID is not set'
      );
      logger.error(err);
      throw err;
    }

    if (rwgToken) {
      await createReserveWithGoogleConversion({
        conversionPartnerId,
        rwgToken,
      });
    }
  });
